import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StoreService } from '../store.service';
import { ApiBaseService } from './api-base.service';
import ApiOptionsConfig from './api-options.config';

const BASE_URL = '/users';

@Injectable({
  providedIn: 'root'
})
export class UserService extends ApiBaseService {

  list(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(BASE_URL), options?.params);
  }

  detail(userId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${userId}`), options?.params);
  }

  create(data: any): Observable<any> {
    return this.POST(this.getUrl(BASE_URL), data);
  }

  update(userId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${userId}`), data);
  }

  delete(userId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${userId}`));
  }

  getMe(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/me`), options?.params)
  }

}